import { io, Socket } from 'socket.io-client';

import { getInstallerAccessToken } from '../../auth/getInstallerAccessToken';

// The server authenticates the socket from the token sent in the handshake. It is read again on every connection,
// so a reconnection always presents the current token.
export function createUiSocket(serverUrl: string): Socket {
    return io(serverUrl, {
        transports: ['websocket'],
        autoConnect: false,
        auth: (sendAuth) => sendAuth({ token: getInstallerAccessToken() }),
    });
}
